import { CartGroup, type BundledQuoteGrouping, type CartGrouping } from "~/features/cart/cart/models/CartData";

export interface BuildTableIdInput {
  groupType: CartGroup;
  quoteNumber?: string | null;
}

const cartGroupKeyMap: Record<CartGroup, string> = {
  [CartGroup.ORDER]: "order",
  [CartGroup.QUOTE]: "quote",
  [CartGroup.BUNDLE]: "bundle",
};

export function getCartGroupKey(groupType: CartGroup): string {
  return cartGroupKeyMap[groupType];
}

export function buildTableId(input: BuildTableIdInput | CartGrouping | BundledQuoteGrouping): string {
  const groupType = "groupType" in input ? input.groupType : input.type;
  const quoteNumber = "quoteNumber" in input ? input.quoteNumber : undefined;
  const scope = quoteNumber ? `:${quoteNumber}` : "";

  return `cart-table:${getCartGroupKey(groupType)}${scope}`;
}

export function buildEntryRowId(cartEntryId: number): string {
  return `cart-entry:${cartEntryId}`;
}

export function buildLineRowId(lineItemId: number): string {
  return `cart-line:${lineItemId}`;
}
